import { Attribute, SearchHandler, SearchResult } from '@/components/Form/AudienceTargeting/Audience/interfaces'

class CollectionEmployeeNumbersSearch implements SearchHandler {
  private attributes: Attribute[]

  constructor(_attr: Attribute, aggregateAttributes: Attribute[]) {
    this.attributes = aggregateAttributes
  }

  async search() {
    // will use variables passed to component so no need to return via async search
    return []
  }

  getAttribute(): Attribute {
    return {
      displayName: 'List of employee numbers',
      id: 'collectionEmployeeNumbers',
      type: 'string',
      scimAttributeName: 'collectionEmployeeNumbers',
      urn: 'collectionEmployeeNumbers'
    }
  }
  getValue(searchResult: SearchResult) {
    return {
      value: `${searchResult.termId}`,
      displayValue: `${searchResult.term}`,
      subtitle: searchResult.subtitle || ''
    }
  }
}

export default CollectionEmployeeNumbersSearch
